"use strict";

exports.__esModule = true;
exports.AnalyticBroker = void 0;
var _PlaybackEventHandler2 = require("../Public/PlaybackEventHandler");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var AnalyticBroker = exports.AnalyticBroker = /*#__PURE__*/function (_PlaybackEventHandler) {
  _inheritsLoose(AnalyticBroker, _PlaybackEventHandler);
  function AnalyticBroker() {
    return _PlaybackEventHandler.apply(this, arguments) || this;
  }
  var _proto = AnalyticBroker.prototype;
  _proto.addParsingError = function addParsingError(_parsingError) {
    throw new Error("Function must be overridden");
  };
  _proto.clearParsingErrors = function clearParsingErrors() {
    throw new Error("Function must be overridden");
  }

  // fire a tracking beacon (AdBreak, Advert, Interactive, AdVerification) unconditionally
  ;
  _proto.fireTrackingReport = function fireTrackingReport(_report) {
    throw new Error("Function must be overridden");
  }

  // fire a creative tracking beacon - click tracking or tracking event
  ;
  _proto.fireTrackingReportForCreative = function fireTrackingReportForCreative(_report, _creative) {
    throw new Error("Function must be overridden");
  }

  // fire an icon tracking beacon - click tracking or tracking event
  ;
  _proto.fireTrackingReportForIcon = function fireTrackingReportForIcon(_report, _icon) {
    throw new Error("Function must be overridden");
  }

  // raise an event notification for a creative
  ;
  _proto.raiseTrackingCallbackForCreative = function raiseTrackingCallbackForCreative(_event, _creative) {
    throw new Error("Function must be overridden");
  };
  _proto.getSessionProperties = function getSessionProperties() {
    throw new Error("Function must be overridden");
  };
  _proto.normaliseAdBreakStart = function normaliseAdBreakStart(_start, _position) {
    throw new Error("Function must be overridden");
  };
  return AnalyticBroker;
}(_PlaybackEventHandler2.PlaybackEventHandler);